/* eslint-disable */

import axios from "services/axiosConfig";

const API_URL = "/api/slot-accounting";

class SlotAccountingService {
  static async getSlotAccountingByLocal(localId, params = {}) {
    try {
      const queryParams = {};

      if (params?.from) queryParams.from = params.from;
      if (params?.to) queryParams.to = params.to;
      if (params?.activeOnly !== undefined) queryParams.activeOnly = params.activeOnly;
      if (params?.includeInitialValues !== undefined) {
        queryParams.includeInitialValues = params.includeInitialValues;
      }
      if (params?.limit) queryParams.limit = params.limit;
      if (params?.before) queryParams.before = params.before;
      if (params?.beforeVisitId) queryParams.beforeVisitId = params.beforeVisitId;

      const { data } = await axios.get(`${API_URL}/local/${localId}`, {
        params: queryParams,
      });

      return data || null;
    } catch (error) {
      console.error("Error al obtener contabilidad de tragamonedas:", {
        localId,
        params,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      throw error;
    }
  }
}

export default SlotAccountingService;
